/* Request Headers */
export const getRequestHeaders = (bankregnr: string | null): { headers: { [key: string]: string } } => ({
    headers: {
        'x-bankregnr': bankregnr || '',
        'Content-Type': 'application/json',
        'X-Requested-By': 'kredittkort-js-client',
    },
});
export default { getRequestHeaders };
